import { createElement, Component, Props as ReactProps } from 'react';
import { DependencyProps } from '../../core/dependency';
import { LocationProps } from '../../core/location';
import { StateProps } from '../../core/state';
import CartSummary from '../components/organisms/CartSummary';
import RootFrame from '../components/templates/RootFrame';
import Order from '../../entity/order';
import Store from '../../entity/store';
import * as _ from 'lodash';
import OrderProduct from "../../entity/orderProduct";

type Props = ReactProps<HTMLDivElement> &
  DependencyProps &
  StateProps &
  LocationProps;

class CartRoute extends Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    this.updateOrderProductField = this.updateOrderProductField.bind(this);
    this.goToPaymentInfo = this.goToPaymentInfo.bind(this);
    this.autoSave = this.autoSave.bind(this);
    this.autoSave = _.debounce(this.autoSave, 500);
  }

  public componentWillMount() {
    this.initialize(this.props);
  }

  public componentWillUnmount() {
    this.dispose(this.props);
  }

  public render() {
    const { dependency, location, state } = this.props;
    const {
      order,
      orderProducts,
      products,
      fetches,
    } = state.cart;
    const currentStore = state.currentStore;
    if (!currentStore) {
      return null;
    }

    const summaries = <CartSummary
      order={order || new Order({})}
      products={products}
      orderProducts={orderProducts}
      updateOrderProductField={this.updateOrderProductField}
      onClickPaymentInfo={this.goToPaymentInfo}
    />;

    return <RootFrame
      {...{ dependency, location, state }}
      content={summaries}
      isSpinner={fetches === 1}
    />;
  }

  private async initialize(props: Props) {
    try {
      await props.dependency.cart.initialize();
    } catch (err) {
      window.console.error(err);
    }
  }

  private updateOrderProductField(orderProduct: OrderProduct, count: number) {
    this.props.dependency.cart.updateEditOrderProductField(orderProduct, count);
    this.autoSave();
  }

  private async autoSave() {
    try {
      await this.props.dependency.cart.save();
    } catch (e) {
      window.console.log(e)
    }
  }

  private async goToPaymentInfo() {
    const store = this.props.state.currentStore as Store;
    window.location.href = store.paymentUri;
  }

  private dispose(props: Props) {
    try {
      props.dependency.cart.dispose();
    } catch (err) {
      window.console.error(err);
    }
  }
}

export default CartRoute;
